import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';

import { GET_JOURNAL } from './constants';

import {
  IJournalState,
  IJournalActionTypes,
  IGetJournalFailure,
  IGetJournalSuccess,
} from './types';

const initialState: IJournalState = {
  status: idle,
  items: [],
  error: null,
  pages: 0,
  count: 0,
};

export default produce(
  (draft = initialState, action: IJournalActionTypes): IJournalState => {
    switch (action.type) {
      case GET_JOURNAL + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case GET_JOURNAL + SUCCESS: {
        draft.status = fulfilled;
        draft.items = (action as IGetJournalSuccess).payload.items;
        draft.pages = (action as IGetJournalSuccess).payload.pages;
        draft.count = (action as IGetJournalSuccess).payload.cnt;
        break;
      }
      case GET_JOURNAL + FAILURE: {
        draft.status = rejected;
        draft.error = (action as IGetJournalFailure).error;
        break;
      }
      case GET_JOURNAL + IDLE: {
        draft.status = idle;
        return draft;
      }
      default:
        return draft;
    }
  },
);
